module.exports = __webpack_public_path__ + "img/clound_1.115aedea.png";